import React from "react";

import { defaultSettings } from "./defaults/settings";
import Component from "./Component";
import Form from "./Form";

const createPlugin = (settings) => {
    const mergedSettings = { ...defaultSettings, ...settings };

    return {
        Component: (props) => <Component {...props} {...mergedSettings} />,
        FormComponent: (props) => <Form {...props} />,

        name: "russells/content/info-panel",
        version: "1.0.0",
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            label: mergedSettings.defaultLabel,
            imageAndTextHeading: "Heading",
            displayOrder: "image-text",
            infoPanelText: "",
            infoPanelPrimaryButtonText: "",
            infoPanelPrimaryButtonColour: "primary",
            infoPanelButtonLink: "",
            infoPanelSecondaryButtonText: "",
            infoPanelSecondaryButtonColour: "secondary",
            infoPanelSecondaryButtonLink: "",
            infoPanelHeadingColour: "text-brand-black",
            backgroundType: "image",
            url: "https://placehold.co/465x540.png",
            mobileUrl: "https://placehold.co/335x320.png",
        }),
    };
};

export default createPlugin;
